import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0180bab9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-address-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], {
        title: `${$props.label} 변경`
      }, null, 8 /* PROPS */, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["Form"], { "validation-schema": $setup.schema }, {
          default: _withCtx(({ meta }) => [
            _createVNode($setup["AddressInput"], {
              class: "input-field",
              name: "address",
              label: `변경할 ${$props.label}`,
              address: $setup.address,
              addressDetail: $setup.address.detailAddress,
              "onUpdate:addressDetail": _cache[0] || (_cache[0] = ($event: any) => (($setup.address.detailAddress) = $event)),
              addressDetailModifiers: { trim: true },
              onOnClickAddressInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleAddressModal(true)))
            }, null, 8 /* PROPS */, ["label", "address", "addressDetail"]),
            _createVNode($setup["BaseButton"], {
              class: "base-button",
              title: "변경",
              disabled: !meta.valid,
              onOnClick: $setup.onClickChangePassword
            }, null, 8 /* PROPS */, ["disabled"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["validation-schema"])
      ]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.isShowAddress,
        onBackHandler: () => $setup.toggleAddressModal(false)
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode($setup["KakaoAddressModal"], {
            onUpdateAddress: $setup.updateAddress,
            onOnClickClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleAddressModal(false)))
          }, null, 512 /* NEED_PATCH */), [
            [_vShow, $setup.isShowAddress]
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}